import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

import { ButtonPrimary } from "../components/button";
import { CustomTextarea } from "../components/input";
import { getCarReportReasons, reportCar } from "../../model/car";
import { commonErr } from "../common/errors";

const CarReport = (props) => {
	const [state, setState] = useState({
		err: commonErr.INNIT,
		errMsg: "",
		reasons: null,
		ip_reason: "",
		ip_comment: "",
	});

	useEffect(() => {
		getCarReportReasons(props.car.id).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS) {
				setState({
					...state,
					err: resp.data.error,
					reasons: resp.data.data.reasons,
				});
			} else {
				setState({
					...state,
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			}
		});

		//clean up when cancel any pending asynchronous processes
		return () => {
			setState({
				err: commonErr.INNIT,
				errMsg: "",
				reasons: null,
				ip_reason: "",
				ip_comment: "",
			});
		};
	}, []);

	const handleInputChange = (event) => {
		setState({
			...state,
			err: commonErr.INNIT,
			errMsg: "",
			[event.target.name]: event.target.value,
		});
	};

	const hideModal = () => {
		setState({
			...state,
			err: commonErr.INNIT,
			errMsg: "",
			ip_reason: "",
		});

		props.hideModal();
	};

	const handleReportCar = () => {
		if (state.ip_reason === "" || (state.ip_reason === "c0" && state.ip_comment === "")) {
			setState({
				...state,
				err: commonErr.FAIL,
				errMsg: "Vui lòng chọn hoặc ghi rõ lý do của bạn.",
			});
		} else {
			reportCar(props.car.id, state.ip_reason, state.ip_comment).then((resp) => {
				if (resp.data.error >= commonErr.SUCCESS) {
					setState({
						...state,
						err: resp.data.error,
						errMsg: resp.data.errorMessage,
					});
					hideModal();
				} else {
					setState({
						...state,
						err: resp.data.error,
						errMsg: resp.data.errorMessage,
					});
				}
			});
		}
	};

	return (
		<Modal show={props.show} onHide={hideModal} dialogClassName="modal-s modal-dialog modal-confirm">
			<Modal.Header closeButton={true} closeLabel={""}>
				<h5>Báo xấu</h5>
			</Modal.Header>
			<Modal.Body>
				<div className="modal-confirm-body traveler-cancel-3-body">
					{state.err <= commonErr.SUCCESS && state.errMsg !== "" && (
						<p className="font-14 text-danger">{state.errMsg}</p>
					)}
					<div className="line-form">
						<div className="custom-input">
							<div className="wrap-info">
								<div className="title-status">
									<p className="font-14">Vui lòng chọn lí do</p>
								</div>
							</div>
							<div className="custom-select">
								<select name="ip_reason" onChange={handleInputChange} value={state.ip_reason}>
									<option value="" disabled hidden>
										Chọn lí do
									</option>
									{state.reasons &&
										state.reasons.map((reason) => (
											<option key={reason.reason} value={reason.reason}>
												{reason.desc}
											</option>
										))}
								</select>
							</div>
						</div>
					</div>
					<CustomTextarea
						name={"ip_comment"}
						placeholder={"Vui lòng nhập lí do hoặc lời nhắn"}
						onChange={handleInputChange}
						value={state.ip_comment}
					/>
					<ButtonPrimary content="Báo cáo" size="M" onClick={handleReportCar} />
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default CarReport;
